import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/test/HelloWorld'
import SSEExample from '@/components/test/SSEExample'
import Chat from '@/components/Chat'
import Home from '@/components/Home'
import Tools from '@/components/Tools'
import Tool from '@/components/Tool'
import Contact from '@/components/Contact'
import Account from '@/components/Account'
import Pay from '@/components/test/Pay'
import ApplyText from '@/components/pay/ApplyText'
import Plans from '@/components/Plans'
import OrderCenter from '@/components/OrderCenter'
import Order from '@/components/Order'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: 'Home',
      component: Home
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    // {
    //   path: '/tools',
    //   name: 'Home',
    //   component: Home
    // },
    // {
    //   path: '/tools/:keyword',
    //   name: 'Home',
    //   component: Home
    // },
    // {
    //   path: '/tools',
    //   name: 'Tools',
    //   component: Tools
    // },
    // {
    //   path: '/tools/:keyword',
    //   name: 'Tool',
    //   component: Tool
    // },
    // {
    //   path: '/contact',
    //   name: 'Contact',
    //   component: Contact
    // },
    {
      path: '/account',
      name: 'Account',
      component: Account,
      meta: {
        requireAuth: true
      }
    },
    // {
    //   path: '/apply',
    //   name: 'ApplyText',
    //   component: ApplyText
    // },
    // {
    //   path: '/plans',
    //   name: 'Plans',
    //   component: Plans
    // },
    // {
    //   path: '/order',
    //   name: 'OrderCenter',
    //   component: OrderCenter,
    //   meta: {
    //     requireAuth: true
    //   }
    // },
    // {
    //   path: '/order/:orderNo',
    //   name: 'Order',
    //   component: Order
    // },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js